module.exports = __webpack_public_path__ + "587d2391188a6f2f2b4e9e3a00d91664.png";